import {LEAGUES} from "../constants/leagues";
import {PLAYER_BONUS_TYPES} from "./playerBonus";

/**
 * Лига-эквивалент бота ЛОКАЛЬНОЙ партии — по уровню бонуса, который игрок
 * выбрал ему при настройке (configs/playerBonus). Своей лиги у такого бота нет:
 * лиги живут в рейтинговых матчах.
 *
 * По эквиваленту бот локальной партии получает то же, что «явный» бот этой
 * лиги в рейтинговом матче:
 *  - значок: иконки ботов названы по лигам (см. getBotMarkIconPath);
 *  - прибавку к росту отрядов за снабжение своей лиги
 *    (configs/botLeagueSupplyGrowth, см. prepareLocalMatchPlayers).
 * Кости у него, как и у явного бота, дает сам уровень бонуса: честные у всех
 * уровней, кроме «божества» (см. getBotD6MinRoll).
 *
 * Соответствие взято у «явных» ботов (VISIBLE_RANKED_BOT_LEAGUE_RULES в
 * configs/visibleRankedBots, сверяется тестом): бот с рубиновым бонусом GREAT
 * и выглядит, и играет одинаково в локальной партии и в рейтинговой.
 * Бронза — уровню «нет»: бронзовый явный бот играет как раз без бонуса. Ее же
 * получает прежний SMALL старых записей (убран из выбора 29.10) — их различает
 * подсказка значка (см. getVisibleBotTitle).
 *
 * В состояние игрока эта лига НЕ пишется (player.leagueId): по этому полю
 * работают механики рейтинговой партии — давление ботов на игрока
 * (applyBotPressureLatches) и подпись значка по лиге (getVisibleBotTitle).
 */
export const LOCAL_BOT_LEAGUE_BY_BONUS = {
  [PLAYER_BONUS_TYPES.NONE]: LEAGUES.BRONZE,
  [PLAYER_BONUS_TYPES.SMALL]: LEAGUES.BRONZE,
  [PLAYER_BONUS_TYPES.MEDIUM]: LEAGUES.SILVER,
  [PLAYER_BONUS_TYPES.BIG]: LEAGUES.GOLD,
  [PLAYER_BONUS_TYPES.LARGE]: LEAGUES.DIAMOND,
  [PLAYER_BONUS_TYPES.GREAT]: LEAGUES.RUBY,
  [PLAYER_BONUS_TYPES.DIVINE]: LEAGUES.GOD,
};

// Лига-эквивалент уровня бонуса; неизвестный уровень — лиги нет
export const getLocalBotLeagueId = (bonusType) => LOCAL_BOT_LEAGUE_BY_BONUS[bonusType] || null;
